import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-vp_pause",
  "use": "n-icon-vp_pause-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-vp_pause\">\n<path d=\"M7.5 8.25C7.5 7.00736 8.50736 6 9.75 6C10.9926 6 12 7.00736 12 8.25V21.75C12 22.9926 10.9926 24 9.75 24C8.50736 24 7.5 22.9926 7.5 21.75V8.25Z\" fill=\"currentColor\" />\n<path d=\"M18 8.25C18 7.00736 19.0074 6 20.25 6C21.4926 6 22.5 7.00736 22.5 8.25V21.75C22.5 22.9926 21.4926 24 20.25 24C19.0074 24 18 22.9926 18 21.75V8.25Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol